export enum EGameType {
  Dota = 'DOTA2',
  CSGO = 'CSGO',
  // COMMON = 'COMMON',
}
export enum EGameTypeSlug {
  Dota = 'dota',
  CSGO = 'cs',
}
